<div class="container">
    <div class="headerContent">
        <a href="" routerLinkActive="active" routerLink="/home" class="logo">
            <img src="./../../../assets/main-logo.svg" alt="">
        </a>
        <app-nav></app-nav>
        
    </div>
</div>
